// extracted by mini-css-extract-plugin
module.exports = {"modal_form_item":"modal-form-item_modal_form_item__5m30v","label":"modal-form-item_label__wgMCK"};